import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function MouthBreathText() {

    
    return (

     <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Take Control of Your Fresh " 
            headline_grey = "Good Breath "
            headline_p2 = " "

            text1 = "Fresh Breath from your mouth involves consistent oral hygiene, dietary habits, and regular oral care."
            text2 = "Your mouth is also home to your oral microbiome — billions of bacteria and fungi. Some cause inflammation, some lead to bad breath, while others keep us healthy."
            text3 = "We test your oral microbiome, identifying the bacteria causing problems and help you get rid of them."

            />
    }/>
            
  )
}